import { render, staticRenderFns } from "./RightChatPanel.vue?vue&type=template&id=5d32a747&scoped=true"
import script from "./RightChatPanel.vue?vue&type=script&lang=js"
export * from "./RightChatPanel.vue?vue&type=script&lang=js"
import style0 from "./RightChatPanel.vue?vue&type=style&index=0&id=5d32a747&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d32a747",
  null
  
)

export default component.exports